<script>
    import ModellApi from '../modell-api'
    import { AjaxRenderingEngine } from '@scripts/ajax-render-engine';
    export default {
        data: function () {
            return {
                selectors: [],
                productPids: [],
                selectedSelectorIds: [],
                selectedPid: -1,
                loading: true,
                myModels:  [],
                modelType: '',
                redirectToMenuIfFound: false,
                levels: 0,
                isAjaxEngineReady: false
            };
        },

        computed: {
            isVisible: function () {
                return true;
            }
        },

        created: function () {

        },
        
        mounted: function () {
            if (!this.isAjaxEngineReady) {
                const formHead = document.querySelector('head');
                formHead.addEventListener('readyForGtm', this.onAjaxRenderEngineReady.bind(this), false);
            }

            

            ModellApi.GetModelSelectorData().then((responseSetup) => {
                if (responseSetup.data != null && responseSetup.data.Levels > 0) {
                    this.modelType = responseSetup.data.ModelType;
                    this.levels = responseSetup.data.Levels;
                    this.redirectToMenuIfFound = responseSetup.data.RedirectToMenuIfFound;
                    
                }
            })
            .finally(() => {
                if (!this.$parent.isPublishMode) {

                    this.initialize();

                    if(this.isAccessoriesPage())
                        ModellApi.getMyModels(this.modelType)
                            .then((response) => {
                                if (response.data !== null && response.data.Success && response.data.Models !== null && response.data.Models != "") {
                                    this.myModels = JSON.parse(response.data.Models);
                                    this.refreshMyModelsContent(this.myModels);

                                    var myModelString = JSON.stringify(this.myModels);
                                    this.saveModelsToLocalStorage(myModelString);
                                }
                                else {
                                    var storedModels = this.getModelsFromLocalStorage();
                                    
                                    if (storedModels !== undefined && storedModels !== null) {
                                        this.refreshMyModelsContent(storedModels);
                                    }
                                }
                            })
                            .finally(() => {
                                this.loading = false;
                            });
                }
            });

        },
        methods: {
            onAjaxRenderEngineReady: function () {
                this.isAjaxEngineReady = true;
            },
            initialize: function () {
                for (var index = 0; index < this.levels; index++) {
                    this.selectors.push(new Array());
                    this.selectedSelectorIds.push(-1);
                }               

                this.updateSelectedGroupsFromPage();

                var alreadySelected = this.getSelectedFromLocalStorage();

                if ((alreadySelected.length > 0) && (alreadySelected.length == this.levels)) {
                    this.setSelectedSelectors(alreadySelected);

                    if (this.isAccessoriesPage())
                        this.showAccessories(null, null, null, true);
                    
                } else {
                    this.getLevel(1, true);
                }
            },

            updateSelectedGroupsFromPage: function () {
                if (this.$parent.activeGroups === undefined || this.$parent.activeGroups === null)
                    return;
                var activeGroups = this.$parent.activeGroups;
                this.loading = true;
                
                for (var index = 0; index < activeGroups.length; index++) {
                    this.selectedSelectorIds[index] = activeGroups[index].Id;
                }
                this.saveSelectedToLocalStorage();
                
                this.loading = false;
            },
            setSelectedSelectors: function (selector) {
                this.loading = true;
                for (var index = 0; index < this.levels; index++) {
                    this.selectedSelectorIds[index] = selector[index];                    
                }
                this.getLevel(1, false);
                this.loading = false;
            },
            isAccessoriesPage: function () {                
                return (window.location.pathname === this.$parent.accessoriesPageUrl) || (this.$parent.accessoriesPageUrl == undefined);
            },

            getMyModelListFieldId: function () {
                var fieldElement = document.querySelector(".model-register-page div[id*='ModelRegisterStoredProductsArea'] + div[id^='A'] .web-pub-field");
                if (fieldElement == null)
                    return null;
                else
                    return fieldElement.getAttribute("data-field-id");
            },
            getMySelectedModelFieldId: function () {
                var fieldElement = document.querySelector(".model-register-page div[id*='ModelRegisterSelectedProductArea'] + div[id^='A'] .web-pub-field");
                if (fieldElement == null)
                    return null;
                else
                    return fieldElement.getAttribute("data-field-id");
            },
            getAccessoriesFieldId: function () {
                //ModelRegisterAccessoriesArea, first field with ListingType.DynamicProductListSetClientSide : 58
                var fieldElement = document.querySelector(".model-register-page div[id*='ModelRegisterAccessoriesArea'] + div[id^='A'] .web-pub-field[data-lt='58']");
                if (fieldElement == null)
                    return null;
                else
                    return fieldElement.getAttribute("data-field-id");
            },

            getLevel: function (levelToGet, thisLevelOnly) {
                this.loading = true;
                ModellApi.getProductSelector(this.modelType, levelToGet, this.selectedSelectorIds)
                    .then((response) => {
                        if (response.data !== null) {
                            this.emptyAndFillSelector(levelToGet, response.data.List);
                        }
                    })
                    .finally(() => {
                        this.loading = false;


                        //Check wether selectedSelector-value can be selected
                        if (!this.selectors[levelToGet - 1].some(item => item.Id == this.selectedSelectorIds[levelToGet - 1])) {
                            //If no:
                            //Reset remaining selectedSelectors, erase any storage and exit.
                            console.log("Cannot select selectedSelector for lvl" + levelToGet + ", selectedSelector on this level:" + this.selectedSelectorIds[levelToGet - 1]);

                            this.resetSelectedIds(levelToGet - 1, null);
                            this.clearAccessories();
                            return;
                        }

                        if (!thisLevelOnly) {
                            //If selector was preselected during emtpyAndFill                            
                            if (this.selectedSelectorIds[levelToGet - 1] > 0) {
                                if ((levelToGet + 1) <= this.levels) {
                                    this.getLevel(levelToGet + 1, false);
                                }
                                else {
                                    this.showAccessories(null, null, null, true);
                                }
                            }
                        }
                    });
            },
            emptyAndFillSelector: function (level, values) {
                if (Array.isArray(values)) {
                    //Empty
                    while (this.selectors[level - 1].length > 0) {
                        this.selectors[level - 1].pop();
                    }
                    if (values.length == 0) {
                        this.selectors[level - 1].push({
                            Id: 0,
                            Name: '-'
                        });
                        this.selectedSelectorIds[level - 1] = 0;
                    } else {
                        values.forEach(function (selector, index) {
                            this.push(selector);
                        }, this.selectors[level - 1]);
                        //If not preselected AND only one item in populated dropdown, select it.
                        if ((this.selectedSelectorIds[level - 1] == -1) && values.length === 1) {
                            this.selectedSelectorIds[level - 1] = values[0].Id;
                        }
                    }
                }
            },
            selectionMade: function (levelSelectionWasMade, evt) {
                const selectedValue = parseInt(evt.target.value, 10);
                if (isNaN(selectedValue))
                    return;
                if (selectedValue<=0) {
                    this.resetSelectedIds(levelSelectionWasMade, null);
                    return;
                }

                if (levelSelectionWasMade == this.levels) {
                    this.showAccessories(null, null, null, true);
                } else {
                    this.resetSelectedIds(levelSelectionWasMade, null);
                    this.getLevel(levelSelectionWasMade + 1, false);
                }
            },
            resetSelectedIds: function (fromLevel, toLevel) {
                var fromIndexLevel = (fromLevel) ? fromLevel : 0;
                var toIndexLevel = (toLevel) ? toLevel : this.levels;
                toIndexLevel = (toIndexLevel > this.levels) ? this.levels : toIndexLevel;
                if (fromIndexLevel >= toIndexLevel)
                    return;

                for (var index = fromIndexLevel; index < toIndexLevel; index++) {
                    this.selectedSelectorIds[index] = -1;
                }
            },
            addSelectedToMyModels : function(plid){
                this.loading = true;
                //get currently stored models
                var myStoredModels = this.getModelsFromLocalStorage();
                //add new model
                if (myStoredModels == undefined || myStoredModels == null){
                    myStoredModels = [];
                }
                var currentModel = this.selectedSelectorIds;

                if (this.containsModel(myStoredModels, currentModel)) {
                    this.loading = false;
                    return;
                }

                myStoredModels.push(currentModel);

                //convert to string we will save in preferences
                var myModelString = JSON.stringify(myStoredModels);
                this.saveModelsToLocalStorage(myModelString);
                ModellApi.saveMyModels(this.modelType, myModelString)
                    .then((response) => {
                    })
                    .finally(() => {
                        this.refreshMyModelsContent(myStoredModels);
                        this.loading = false;
                    });
            },

            containsModel : function(array, model){
                for(var i = 0; i < array.length; i++){
                    if(this.modelsMatch(array[i], model))
                        return true;
                }
                return false;
            },

            modelsMatch: function (model1, model2) {
                return model1.join() == model2.join();
            },

            getModelsFromLocalStorage : function(){
                var myStoredModels = window.StorageService.localStorage.getItem("ModelRegister." + this.modelType);
                if (myStoredModels !== undefined && myStoredModels !== null && myStoredModels !== "")
                    return JSON.parse(myStoredModels.replace(/"/g, ''));
                else return null;
            },
            saveModelsToLocalStorage :  function(models){
                window.StorageService.localStorage.setItem("ModelRegister." + this.modelType, models.replace(/"/g, ''));
            },

            saveSelectedToLocalStorage: function () {
                this.saveToLocalStorage(this.selectedSelectorIds);
            },

            saveToLocalStorage: function (selector) {
                window.StorageService.localStorage.setItem("ModelRegister.Selected" + this.modelType, selector);
            },
            getSelectedFromLocalStorage: function () {
                var localStoredSelector = window.StorageService.localStorage.getItem("ModelRegister.Selected" + this.modelType);
                if (localStoredSelector !== undefined && localStoredSelector !== null)
                    return localStoredSelector.split(',');
                else
                    return [-1]; 
            },
            addModel: function (plid) {
                this.addSelectedToMyModels();
            },
            removeModel: function (plid) {
                var storedModels = this.getModelsFromLocalStorage();

                var plidPosition = -1;
                for (var index = 0; index < storedModels.length; index++) {
                    if (storedModels[index][this.levels - 1] == plid)
                        plidPosition = index;
                }
                if (plidPosition != -1)
                    storedModels.splice(plidPosition, 1);
                
                var modelsString = JSON.stringify(storedModels);
                this.saveModelsToLocalStorage(modelsString);
                ModellApi.saveMyModels(this.modelType, modelsString)
                    .then((response) => {
                    })
                    .finally(() => {
                        this.refreshMyModelsContent(storedModels);
                        this.loading = false;
                    });
                
            },
            selectModel: function (plid) {
                var storedModels = this.getModelsFromLocalStorage();

                var plidPosition = -1;
                for (var index = 0; index < storedModels.length; index++) {
                    if (storedModels[index][this.levels - 1] == plid)
                        plidPosition = index;
                }
                if (plidPosition != -1) {
                    this.saveToLocalStorage(storedModels[plidPosition]);
                    this.setSelectedSelectors(storedModels[plidPosition]);
                }
            },
            clearAccessories: function () {
                var accessoriesFieldId = this.getAccessoriesFieldId();
                this.updateFieldWithPlids(accessoriesFieldId, null, null);
            },
            showAccessories: function (sender, args, plid, doNotRedirect) {
                this.loading = true;
                this.clearAndSetSpinner(this.getAccessoriesFieldId());
                this.saveSelectedToLocalStorage();

                if (this.redirectToMenuIfFound) {
                    // Menu-node-based accessories-listing
                    var selectedIds = this.getSelectedIds(plid);

                    if (!!doNotRedirect || this.productGroupMatch(selectedIds, this.$parent.activeGroups)) {
                        this.loading = false;
                        return;
                    } else {
                        ModellApi.getRedirectData(selectedIds[0], selectedIds[1], selectedIds[2])
                            .then((response) => {
                                if (response.data.DoRedirect) //Redirect to correct page
                                    window.location.href = response.data.RedirectUrl;
                                else //Fallback = Classic
                                    this.showAccessoriesStandard(plid, !!doNotRedirect);
                            });
                    }
                } else {
                    // Classic 
                    this.showAccessoriesStandard(plid, !!doNotRedirect);
                }
            },

            showAccessoriesStandard: function (plid, doNotRedirect) {
                if (this.isAccessoriesPage()) {
                    this.updateFieldWithPlids(this.getMySelectedModelFieldId(), this.getSelectedPlid(plid));
                    ModellApi.getPlid(this.modelType, this.getSelectedIds())
                        .then((response) => {
                            if (response.data !== null) {
                                var accessoriesPlids = new Array();
                                for (var index = 0; index < response.data.length; index++) {
                                    accessoriesPlids.push(response.data[index].Plid);
                                }
                                var accessoriesFieldId = this.getAccessoriesFieldId();
                                this.updateFieldWithPlids(accessoriesFieldId, accessoriesPlids.join(), response.data);                                                                
                            }

                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
                else {
                    if (doNotRedirect) {
                        console.log("Cannot use page to display accessories.");
                        this.loading = false;
                    }
                    else {
                        window.location.href = this.$parent.accessoriesPageUrl;
                    }
                }

            },
            getSelectedIds: function (plid) {
                var selectedIds = [];
                if (plid === undefined || plid === null)
                    selectedIds = JSON.parse(JSON.stringify(this.selectedSelectorIds));
                else {
                    for (var index = 0; index < this.levels; index++) {
                        selectedIds.push(0);
                    }
                    selectedIds[this.levels - 1] = plid;
                }
                return selectedIds;
            },

            getSelectedPlid: function (plid) {
                var selectedPlid = new Array();
                if (plid === undefined || plid === null)
                    selectedPlid.push(this.selectedSelectorIds[this.levels - 1]);
                else
                    selectedPlid.push(plid);
                return selectedPlid;                
            },

            productGroupMatch: function (groupA, groupB) {
                if (groupA === undefined || groupA === null)
                    return false;
                if (groupB === undefined || groupB === null)
                    return false;

                if (groupA.length < 3 || groupB.length < 3)
                    return false;
                if (groupA[0] != groupB[0].Id ||
                    groupA[1] != groupB[1].Id ||
                     groupA[2] != groupB[2].Id)
                    return false;

                return true;

            },

            refreshMyModelsContent: function (models) {
                var plids = [];
                for (var i = 0; i < models.length; i++){
                    if(models[i].length==this.levels)
                        plids.push(models[i][this.levels-1]);
                }
                if (plids.length > 0)
                    this.clearAndSetSpinner(this.getMyModelListFieldId());
                jQuery("#myModels").collapse('show');
                this.updateFieldWithPlids(this.getMyModelListFieldId(),plids.join());

            },

            clearAndSetSpinner: function (fieldId) {
                if (fieldId == null || !this.isAccessoriesPage())
                    return;
                // IE11 no support
                if (!document.replaceChildren) 
                    return;
                    
                var spinnerNode = document.createElement("span");
                spinnerNode.setAttribute('class', 'icon-spinner animate-spin');
                var field = document.querySelector(".model-register-page .field-container-" + fieldId + " .ajax-field");
                if (field !== null)
                    field.replaceChildren(spinnerNode);
            },
            updateFieldWithPlids: function (fieldId, plids, extraData) {
                var data = null;
                if (extraData !== undefined)
                    data = extraData;

                if (this.isAjaxEngineReady) {
                    PubSub.publish("AjaxRenderingEngine.onPushProductsIntoField",
                        {
                            FieldId: fieldId,
                            Plids: plids,
                            ExtraData: data
                        });
                } else {

                    var ajaxRenderCheckCounter = 0;
                    var that = this;
                    var ajaxRenderCheck = setInterval(function () {
                        ajaxRenderCheckCounter++;
                        if (ajaxRenderCheckCounter > 100) {
                            clearInterval(ajaxRenderCheck);
                            console.log("100 attempts without ready. Stopping.");
                        }

                        if (that.isAjaxEngineReady || (
                            AjaxRenderingEngine !== undefined
                            && AjaxRenderingEngine.InitialLoadDone !== undefined
                            && AjaxRenderingEngine.InitialLoadDone)) {
                            clearInterval(ajaxRenderCheck);
                            that.isAjaxEngineReady = true;
                            PubSub.publish("AjaxRenderingEngine.onPushProductsIntoField",
                                {
                                    FieldId: fieldId,
                                    Plids: plids,
                                    ExtraData: data
                                });
                        }
                    }, 200);
                }
            }

        }
    }
</script>

<template>
    <div class="form-group modell-select" v-bind:class="'selector-count-'+ levels" v-if="isVisible">
        <template v-for="selectorNo in levels">
            <select class="form-control" :disabled="(selectorNo==1) ? loading : (loading || (selectedSelectorIds[(selectorNo-2)] <= 0))" v-model="selectedSelectorIds[selectorNo-1]" @change="selectionMade(selectorNo, $event)">
                <option value="-1">
                    {{ (selectorNo==1) ? $t('Modellregister.ProdCat'+selectorNo) : (selectedSelectorIds[(selectorNo-2)] <= 0) ? $t('Modellregister.ChooseProdCat'+ (selectorNo-1) +'First') : $t('Modellregister.ProdCat'+selectorNo) }}
                </option>
                <option v-for="selector in selectors[selectorNo-1]" v-bind:value="selector.Id" v-bind:key="selector.Id">{{ selector.Name }}</option>
            </select>
        </template>
        <button type="button" class="form-control" v-on:click.stop="showAccessories" :disabled="selectedSelectorIds[levels-1] == -1">{{ $t('Modellregister.ShowAccessories') }}</button>
    </div>
</template>